import { Box, keyframes } from "@mui/material";
import { useState, useEffect } from "react";

const rise = keyframes`
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(-120vh) scale(0.5);
    opacity: 0;
  }
`;

type StyleType = {
  id: number;
  size: number;
  left: number;
  delay: number;
  duration: number;
  color: string;
};

const Bubble = ({ size, left, delay, duration, color }: any) => (
  <Box
    sx={{
      position: "absolute",
      bottom: -50,
      width: size,
      height: size,
      borderRadius: "50%",
      backgroundColor: "rgba(255,255,255,0.3)",
      left: `${left}%`,
      bgcolor: color,
      animation: `${rise} ${duration}s linear ${delay}s infinite`,
    }}
  />
);

const Bubbles = () => {
  const [bubbles, setBubbles] = useState<StyleType[]>([]);

  useEffect(() => {
    const count = 40;
    const list = Array.from({ length: count }, (_, i) => ({
      id: i,
      size: Math.random() * 20 + 10,
      left: Math.random() * 100,
      delay: Math.random() * 5,
      duration: Math.random() * 10 + 5,
      color: `hsl(${Math.random() * 360}, 70%, 60%)`,
    }));
    setBubbles(list);
  }, []);

  return (
    <Box sx={{ position: "relative", width: "100%", height: "100vh", overflow: "hidden" }}>
      {bubbles.map(b => (
        <Bubble key={b.id} {...b} />
      ))}
    </Box>
  );
};

export default Bubbles;
